module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Pre and Post Assessment Discounts",
      "icon": "table-e-f-discounts"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pre_or_pos",
      "label": "Discount Type"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.preOrPost),
      expression: "preOrPost"
    }],
    ref: "preOrPost",
    attrs: {
      "required": "",
      "name": "pre_or_pos"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.preOrPost = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handler]
    }
  }, [_c('option', {
    attrs: {
      "value": "null",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pre"
    }
  }, [_vm._v("Pre-Assessment Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "post"
    }
  }, [_vm._v("Post-Assessment Discount")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('pre_or_pos')
    }
  }, [_vm._v("\n                    Please select Pre or Post\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "gender",
      "label": "Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    ref: "gender",
    attrs: {
      "required": "",
      "name": "gender"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handler]
    }
  }, [_c('option', {
    attrs: {
      "value": "null",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('gender')
    }
  }, [_vm._v("\n                    The gender is required\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_birth",
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfBirth",
    on: {
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_death')
    }
  }, [_vm._v("\n                    The Date of Death is required and must be in the format DD/MM/YYYY\n                    and The Age of Deceased has to be between 10 - 90\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_of_deceased",
      "label": "Age of Deceased",
      "no-flex-margin": true,
      "vertical-centre": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ageOfDeceased),
      expression: "ageOfDeceased"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    ref: "ageOfDeceased",
    attrs: {
      "autocomplete": "off",
      "name": "age_of_deceased",
      "required": "",
      "min": "10",
      "max": "90",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageOfDeceased)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageOfDeceased = $event.target.value
      }, _vm.handler]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('age_of_deceased') || !_vm.ageRules
    }
  }, [_vm._v("\n                    The Age of Deceased has to be between 10 - 90\n                ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "u-accent u-r-margin-top-20 u-d-block"
  }, [_vm._v("or")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_of_deceased",
      "label": "Date of Death",
      "vertical-centre": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:dateOfDeath.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "dateOfDeath",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfDeath",
    on: {
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfDeath),
      callback: function($$v) {
        _vm.dateOfDeath = $$v
      },
      expression: "dateOfDeath"
    }
  })], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_trial_or_cessation",
      "label": "Date of Trial"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_trial_or_cessation.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_trial_or_cessation",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfTrialOrCessation",
    on: {
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfTrialOrCessation),
      callback: function($$v) {
        _vm.dateOfTrialOrCessation = $$v
      },
      expression: "dateOfTrialOrCessation"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_trial_or_cessation') || !_vm.dateOfTrialOrCessationRules
    }
  }, [_vm._v("\n                    The Date of Trial is required and must be in the format DD/MM/YYYY\n                    and can not be more than 9 years after the Date of Death\n                ")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "discount_result",
      "label": _vm.discountResultLabel
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.discountResult),
      expression: "discountResult"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "discount_result",
      "type": "number",
      "name": "discount_result"
    },
    domProps: {
      "value": (_vm.discountResult)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discountResult = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                To calculate the factor by which pre or post-trial damages should be discounted, Ogden Tables E and F\n                are used, respectively.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Using Ogden Table " + _vm._s(_vm.preOrPost == 'pre' ? "E" : "F") + " the factor by which\n                " + _vm._s(_vm.preOrPost) + "-trial damages should be discounted can be calculated using the age of the deceased at\n                the date of death and the number of years between the date of death and the\n                date of trial/assumed settlement.\n            ")]), _vm._v(" "), (_vm.tableData !== null) ? _c('div', {
    staticClass: "a-table--really-wide"
  }, [_c('table', {
    staticClass: "a-table a-table--modal a-table--really-wide"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('div', {
    staticClass: "u-text-center"
  }, [_vm._v("\n                                Period from date of accident to date of trial or assumed settlement\n                            ")])])]), _vm._v(" "), _c('tr', _vm._l((_vm.tableData.table.thead), function(column) {
    return _c('th', [_vm._v("\n                            " + _vm._s(column) + "\n                        ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.table.tbody), function(row) {
    return _c('tr', _vm._l((row), function(column, index) {
      return _c('td', [_vm._v("\n                            " + _vm._s(index === 0 || index === 5 ? column : _vm.currencyFormat(column, '')) + "\n                        ")])
    }), 0)
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("\n                Calculation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The age of the deceased at the date of the accident was\n                " + _vm._s(_vm.ageOfDeceased) + " years old and the period from the date of the accident to the date of\n                trial or assumed settlement of\n                dependency was " + _vm._s(_vm.periodBetweenDodAndDot) + " years.\n            ")]), _vm._v(" "), (_vm.explanation !== null) ? _c('p', [_vm._v("\n                " + _vm._s(_vm.explanation) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n                Through interpolation it has been deduced that the\n                " + _vm._s(_vm.preOrPost) + "-assessment discount is: "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.discountResult, '')))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50e7ff54!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/tableDiscounts.vue
// module id = 1687
// module chunks = 0